import script from "./headingAndText.vue?vue&type=script&setup=true&lang=js"
export * from "./headingAndText.vue?vue&type=script&setup=true&lang=js"

import "./headingAndText.vue?vue&type=style&index=0&id=f7e9be2c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7e9be2c"]])

export default __exports__